module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_library.js
// module id = H0Ax
// module chunks = 0